import * as yup from "yup";
import { initializeYup } from "@duosoftbg/nacid-components";

export const createCategoryLinkValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};
